"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  key: 'unique',
  ignore: true
}, {
  key: 'validateOn',
  ignore: true
}];
exports.default = _default;